import util from '@bmp-vue/core/api/util'

const controller = 'ErrorService'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  constructor () {
    // this.initHandler();
  },

  onError (error) {
    this.Errors.push({ message: error.message, stack: error.stack })
    throw error
  },
  Errors: [],

  RegisterError: function (dto) {
    const scope = this
    if (scope.Errors && scope.Errors.length > 0) {
      util.Axios.Post('LogAcesso/RegisterError', { dto, consoleErrors: scope.Errors }).then(function () {
        scope.Errors = []
      })
    }
  }
})
